import { Helpers } from '../core/src/helpers';

/**
 * Check window for pStoreID
 * (which is set lib\web\app\core\src\etr-api-client\services.jsx from the HPServices response)
 * @param {*} path
 * @returns
 */
const pathInterceptor = path => {
    try {
        if (window.pStoreID && path.indexOf(`pStoreID=${window.pStoreID}`) < 0) {
            path = Helpers.addUrlParam(path, { pStoreID: window.pStoreID }, true);
        }
    } catch (e) {}
    return path;
};

/**
 * Monkey patch history (don't think we need to add the pStoreID on replace)
 * @param {*} originalHistory
 * @returns
 */
const historyEnhancer = originalHistory => {
    return {
        ...originalHistory,
        push: (path, ...args) => originalHistory.push(pathInterceptor(path), ...args),
    };
};

export default historyEnhancer;
